import * as React from 'react'

const ActiveTripsStatistic = () => (
  <div className='py2 bb-light-grey4'>
    <div className='flex justify-between '>
      <div className='h5 font-dark-grey'>Time to accept</div>
      <div className='h6 font-green'>4%</div>
    </div>
    <div className='flex justify-between h5'>
      <div className='h6 font-grey2'>Average time to accept ride</div>
      <div className='h5 font-dark-grey'>1.3m</div>
    </div>
  </div>
)

export default ActiveTripsStatistic



// WEBPACK FOOTER //
// ./src/components/trips/ActiveTripsStatistic.tsx